import '../../App.scss'
import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from "react-router-dom";
import GlyphsList from './GlyphsList'
import ViewGlyph from './viewGlyph'
import Seo from '../seo/Seo';
import HeroMystery from './HeroMystery';

class MysteryGlyphs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (
            <div className="Museum">
                <Seo 
                title="Mystery Glyphs"
                image="https://1.bp.blogspot.com/-pBlgX3Qxfxc/YCxWzX2JuiI/AAAAAAAAnAw/1AxVaA_0dqUWsqry5XJoFX5v2nIsZ5kDgCLcBGAsYHQ/s1920/Mystery%2BGlyphs%2BCover.jpg"
                description="Across the Western United States a Mystery is Unfolding"

                />
              <HeroMystery/>
                <Switch>
                    <Route exact path='/mysteryglyphs/' component={GlyphsList} />
                    <Route path='/mysteryglyphs/post/:blogid/:postid/:title' component={ViewGlyph} />
                </Switch>
                <div className="MuseumFooter">
                    <h1></h1>
                        <h2>Found something interesting? We want to hear from you!</h2>
                    <div id="widebutton"className="Register">
                        <p>Submit Exhibit for Display</p>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(MysteryGlyphs) 
